import { useContext, useEffect } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";

export const BookingEnd = () => {
	const nextPage = "thankYouPage";
	const previousPage = "selectDateTime";

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const { data, setData, companies, setCompanies, isTransitioning, errors } =
		useContext(AppContext);

	useEffect(() => {
		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		if (data.locator) {
			fetch(`${API_URL}/query/companies?locator=${data.locator}`, options)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setCompanies(newData.companies);
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}
	}, [data.locator, setCompanies]);

	return (
		<div
			className={
				"content booking_end kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_booking_form">
				<div className="booking_form_title">
					<h2>
						<strong>
							Solo necesitamos estos datos para confirmar tu cita
						</strong>
					</h2>
					<span>
						Confirma tu cita para tu
						<strong>{" " + data.brand + " " + data.model}</strong>
					</span>
				</div>

				<div className="booking_form_content">
					<div className="booking_form_vehicle">
						<p>Datos del vehículo</p>
						<form>
							<label>
								<strong>Matrícula</strong>
								<input
									type="text"
									defaultValue={data ? data.plate : ""}
									onChange={(e) =>
										setData({
											...data,
											plate: e.target.value,
										})
									}
								/>
								{errors.plate && (
									<span className="error">
										{errors.plate}
									</span>
								)}
							</label>
							<label>
								<strong>Aseguradora</strong>
								<select
									value={data?.insurance || ""}
									onChange={(e) =>
										setData({
											...data,
											insurance: e.target.value,
										})
									}
									disabled={data?.noInsurance}
								>
									<option value="">Elige tu seguro</option>
									{companies &&
										companies.map((company, index) => (
											<option key={index} value={company}>
												{company}
											</option>
										))}
								</select>
								{errors.insurance && (
									<span className="error">
										{errors.insurance}
									</span>
								)}
							</label>
							<label className="no_insurance">
								<input
									type="checkbox"
									checked={!!(data && data.noInsurance)}
									onChange={(e) =>
										setData({
											...data,
											noInsurance: e.target.checked,
											insurance: e.target.checked
												? ""
												: data.insurance,
										})
									}
								/>
								No tengo aseguradora
							</label>
						</form>
					</div>

					<div className="booking_form_user">
						<p>Tus datos</p>
						<form>
							<label>
								<strong>Email</strong>
								<input
									type="email"
									defaultValue={data ? data.email : ""}
									onChange={(e) =>
										setData({
											...data,
											email: e.target.value,
										})
									}
								/>
								{errors.email && (
									<span className="error">
										{errors.email}
									</span>
								)}
							</label>
							<label>
								<strong>Nombre y Apellidos</strong>
								<input
									type="text"
									defaultValue={data ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.target.value,
										})
									}
								/>
								{errors.name && (
									<span className="error">{errors.name}</span>
								)}
							</label>
							<label>
								<strong>Teléfono</strong>
								<input
									type="tel"
									defaultValue={data ? data.phone : ""}
									onChange={(e) =>
										setData({
											...data,
											phone: e.target.value,
										})
									}
								/>
								{errors.phone && (
									<span className="error">
										{errors.phone}
									</span>
								)}
							</label>
							<label className="privacy_policy">
								<input
									type="checkbox"
									checked={!!(data && data.privacy_policy_2)}
									onChange={(e) =>
										setData({
											...data,
											privacy_policy_2: e.target.checked,
										})
									}
								/>
								<span className="link">
									Acepto la{" "}
									<a
										href="https://www.ralarsa.com/es/privacidad/"
										target="_blank"
										rel="noopener noreferrer"
									>
										política de privacidad
									</a>
								</span>
							</label>
						</form>
						<span>
							En virtud de lo establecido en el Reglamento (UE)
							2016/679 del Parlamento Europeo y del Consejo, de 27
							de abril de 2016 (RGPD) así como en la Ley Orgánica
							3/2018 de 5 de diciembre, de Protección de Datos
							Personales y garantía de los derechos digitales
							(LOPDGDD), RALARSA HOLDING S.L., informa que los
							datos obtenidos a través de los siguientes
							formularios serán tratados por ésta con la finalidad
							de poder identificar el servicio solicitado por el
							usuario para concertar una cita previa, pudiendo
							contactarle mediante llamada telefónica. Si lo desea
							puede ejercer sus derechos de acceso, rectificación,
							supresión, oposición, limitación del tratamiento y/o
							portabilidad de los datos mediante tal y como se
							establece en la información adicional. Puede
							consultar la información adicional y detallada sobre
							Protección de Datos acudiendo a nuestra Política de
							privacidad.
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};
